module.exports = __webpack_public_path__ + "static/media/TUNE_4431.637530de.jpg";